import { ExternalProvider } from '../enums/external-provider.enum';
import { EntityExtractorMap } from '../types/entity-extractor-map.type';
import { nluNames } from './nlu-names.constant';

export const entityExtractorNames: EntityExtractorMap<string> = {
    ...nluNames,
    [ExternalProvider.Stanford]: 'Stanford CoreNLP'
}